export default __webpack_public_path__ + "static/media/4.96427ab1.jpg";